import globals from '#utilities/js/ea/globals.js'
import { meetProps, scopeProps } from './props.js'

export default () => {
  const { dial, organizer } = meetProps()
  const { myself } = scopeProps()
  const is_organizer = organizer === myself
  if (dial)
    is_organizer ? globals.ea_rainbow_confstop() : globals.ea_rainbow_confquit()
  else
    globals.ea_rainbow_videostop()
}

